import React from "react";
import SiteNotificationCtrl from './SiteNotificationCtrl';

import { getText, getHtml } from 'Common/utility/utils.js';

export default class SiteNotification extends React.Component {
  render() {
    const config = this.props.config;
    if (!config) {
      return 'Loading';
    }

    const props = {
      type: getText(config, 'type'),
      title: getText(config, 'title'),
      description: getHtml(config, 'description'),
    }

    return (
      <SiteNotificationCtrl {...props} />
    );
  }
}
